import ModelActionsService from 'services/storageModelActions/ModelActionsService';
import IDocumentTemplateActionsService from './IDocumentTemplateActionsService';
import { DocumentTemplateRequestDTO, DocumentTemplateResponseDTO, GetDocumentTemplateListRequestDTO } from 'typings/dto/documentTemplate';
import DIContainer from 'services/DIContainer';
import ISliceActions from 'storage/slices/ISliceActions';
import IMapper from 'utils/mappers/IMapper';
import IEntityApiService from 'services/entityApi/IEntityApiService';
import IModelApiService from 'services/entityApi/IModelApiService';
import IServerEventsService from 'services/serverEvents/IServerEventsService';
import { AppDispatch, RootState } from 'storage';
import { PATH_BACKEND } from 'configs/routes/pathsBackend';
import FrontendRoutesBase from 'services/routing/dashboard/FrontendRoutesBase';

export default class DocumentTemplateActionsServiceImpl
  extends ModelActionsService<DocumentTemplate, DocumentTemplateRequestDTO, DocumentTemplateResponseDTO>
  implements IDocumentTemplateActionsService
{
  constructor(
    modelStorageData: { name: DIContainer.ModelsWithActionServices; actions: ISliceActions<DocumentTemplate> },
    modelMapper: IMapper<DocumentTemplate, DocumentTemplateResponseDTO>,
    entityApiService: IEntityApiService,
    modelApiService: IModelApiService,
    subEntitiesApiServices: DIContainer.SubEntitiesApiServices,
    modelApiRootPath: string,
    serverEventsService: IServerEventsService,
    storageStateGetter: () => RootState,
    storageDispatch: AppDispatch
  ) {
    super(
      modelStorageData,
      modelMapper,
      entityApiService,
      modelApiService,
      subEntitiesApiServices,
      modelApiRootPath,
      serverEventsService,
      storageStateGetter,
      storageDispatch
    );
  }

  public delete = async (id: string, customPath?: string, dto?: Record<string, any>): Promise<void> => {
    if (!dto?.fileId) {
      throw new Error('fileId is required to delete the file from S3');
    }

    try {
      await this.subEntitiesApiServices.file.deleteOne(dto.fileId);
      const path = customPath || `${PATH_BACKEND.documentTemplate.root}`;
      await this.modelApiService.delete(path, id);
    } catch (error) {
      throw new Error(`Failed to delete documentTemplate or file: ${error}`);
    }
  };
}
